export default __webpack_public_path__ + "static/media/AFlightToNYC_05.16a62a36.png";